import Go_Arithmetic from "./go_components/Go_Arithmetic";
import Go_Arrays from "./go_components/Go_Arrays";
import Go_Assignment from "./go_components/Go_Assignment";
import Go_Bitwise from "./go_components/Go_Bitwise";
import Go_Boolean from "./go_components/Go_Boolean";
import Go_Certificate from "./go_components/Go_Certificate";
import Go_Comments from "./go_components/Go_Comments";
import Go_Comparison from "./go_components/Go_Comparison";
import Go_Compiler from "./go_components/Go_Compiler";
import Go_Concurrency from "./go_components/Go_Concurrency";
import Go_Conditions from "./go_components/Go_Conditions";
import Go_Constants from "./go_components/Go_Constants";
import Go_Data_Types from "./go_components/Go_Data_Types";
import Go_else_if_Statement from "./go_components/Go_else_if_Statement";
import Go_Error_Handling from "./go_components/Go_Error_Handling";
import Go_Exercises from "./go_components/Go_Exercises";
import Go_Float from "./go_components/Go_Float";
import Go_Formatting_Verbs from "./go_components/Go_Formatting_Verbs";
import Go_Functions from "./go_components/Go_Functions";
import Go_Functions_Recursion from "./go_components/Go_Functions_Recursion";
import Go_Functions_Returns from "./go_components/Go_Functions_Returns";
import Go_Get_Started from "./go_components/Go_Get_Started";
import Go_Home from "./go_components/Go_Home";
import Go_if_else_Statement from "./go_components/Go_if_else_Statement";
import Go_if_statement from "./go_components/Go_if_statement";
import Go_Integer from "./go_components/Go_Integer";
import Go_Introduction from "./go_components/Go_Introduction";
import Go_Logical from "./go_components/Go_Logical";
import Go_Loops from "./go_components/Go_Loops";
import Go_Maps from "./go_components/Go_Maps";
import Go_Modify_Slices from "./go_components/Go_Modify_Slices";
import Go_Multiple_Variable from "./go_components/Go_Multiple_Variable";
import Go_Multi_case from "./go_components/Go_Multi_case";
import Go_Nested_if_Statement from "./go_components/Go_Nested_if_Statement";
import Go_Operators from "./go_components/Go_Operators";
import Go_Output from "./go_components/Go_Output";
import Go_Packages_Modules from "./go_components/Go_Packages_Modules";
import Go_Parameters_and_Arguments from "./go_components/Go_Parameters_and_Arguments";
import Go_Slices from "./go_components/Go_Slices";
import Go_String from "./go_components/Go_String";
import Go_Struct from "./go_components/Go_Struct";
import Go_Study_Plan from "./go_components/Go_Study_Plan";
import Go_Switch from "./go_components/Go_Switch";
import Go_Syllabus from "./go_components/Go_Syllabus";
import Go_Syntax from "./go_components/Go_Syntax";
import Go_Tools from "./go_components/Go_Tools";
import Go_Tutorial from "./go_components/Go_Tutorial";
import Go_Variables from "./go_components/Go_Variables";
import Go_Variable_Naming from "./go_components/Go_Variable_Naming";

const AllGoComponents = {
  "<Go_Arithmetic />": Go_Arithmetic,
  "<Go_Arrays />": Go_Arrays,
  "<Go_Assignment />": Go_Assignment,
  "<Go_Bitwise />": Go_Bitwise,
  "<Go_Boolean />": Go_Boolean,
  "<Go_Certificate />": Go_Certificate,
  "<Go_Comments />": Go_Comments,
  "<Go_Comparison />": Go_Comparison,
  "<Go_Compiler />": Go_Compiler,
  "<Go_Concurrency />": Go_Concurrency,
  "<Go_Conditions />": Go_Conditions,
  "<Go_Constants />": Go_Constants,
  "<Go_Data_Types />": Go_Data_Types,
  "<Go_else_if_Statement />": Go_else_if_Statement,
  "<Go_Error_Handling />": Go_Error_Handling,
  "<Go_Exercises />": Go_Exercises,
  "<Go_Float />": Go_Float,
  "<Go_Formatting_Verbs />": Go_Formatting_Verbs,
  "<Go_Functions />": Go_Functions,
  "<Go_Functions_Recursion />": Go_Functions_Recursion,
  "<Go_Functions_Returns />": Go_Functions_Returns,
  "<Go_Get_Started />": Go_Get_Started,
  "<Go_Home />": Go_Home,
  "<Go_if_else_Statement />": Go_if_else_Statement,
  "<Go_if_statement />": Go_if_statement,
  "<Go_Integer />": Go_Integer,
  "<Go_Introduction />": Go_Introduction,
  "<Go_Logical />": Go_Logical,
  "<Go_Loops />": Go_Loops,
  "<Go_Maps />": Go_Maps,
  "<Go_Modify_Slices />": Go_Modify_Slices,
  "<Go_Multiple_Variable />": Go_Multiple_Variable,
  "<Go_Multi_case />": Go_Multi_case,
  "<Go_Nested_if_Statement />": Go_Nested_if_Statement,
  "<Go_Operators />": Go_Operators,
  "<Go_Output />": Go_Output,
  "<Go_Packages_Modules />": Go_Packages_Modules,
  "<Go_Parameters_and_Arguments />": Go_Parameters_and_Arguments,
  "<Go_Slices />": Go_Slices,
  "<Go_String />": Go_String,
  "<Go_Struct />": Go_Struct,
  "<Go_Study_Plan />": Go_Study_Plan,
  "<Go_Switch />": Go_Switch,
  "<Go_Syllabus />": Go_Syllabus,
  "<Go_Syntax />": Go_Syntax,
  "<Go_Tools />": Go_Tools,
  "<Go_Tutorial />": Go_Tutorial,
  "<Go_Variables />": Go_Variables,
  "<Go_Variable_Naming />": Go_Variable_Naming,
};

export default AllGoComponents;
